import { ApiResponse } from './api';

export type PromoCodesType =
  | 'companyCampaign'
  | 'userReferral'
  | 'affiliationMarketing'
  | 'influencerMarketing'
  | 'associatedPartner';

export const PromoCodeTypesEnum = {
  companyCampaign: 'Company Campaign',
  userReferral: 'User Referral',
  affiliationMarketing: 'Affiliation Marketing',
  influencerMarketing: 'Influencer Marketing',
  associatedPartner: 'Associated Partner',
};

export type PromoCode = {
  id: number;
  name: string;
  code: string;
  maxUses: number;
  currentUses: string;
  type: PromoCodesType | string;
  isActive: boolean;
  expirationDate: string;
  // associatedPartner?: string
  createdAt: Date | string;
  updatedAt: Date | string;
};

export type PromoCodeUsages = {
  id: number;
  name: string;
  email: string;
  phone: number;
  nationalId: number;
  createdAt: Date | string;
  updatedAt: Date | string;
};

export type FetchPromoCodeResponse = ApiResponse<PromoCode>;
export type FetchPromoCodesResponse = ApiResponse<{ items: PromoCode[]; totalItems: number }>;

export type FetchPromoCodeUsagesResponse = ApiResponse<{ items: PromoCodeUsages[]; totalItems: number }>;

export type CreatePromoCodeRequest = Omit<PromoCode, 'id' | 'currentUses' | 'createdAt' | 'updatedAt'>;
export type CreatePromoCodeResponse = ApiResponse<PromoCode>;

export type UpdatePromoCodeRequest = Omit<PromoCode, 'currentUses' | 'createdAt' | 'updatedAt'>;
export type UpdatePromoCodeResponse = ApiResponse<PromoCode>;
